import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as filesActions } from '../../../actions/filesActions';
import { MOBILE_WINDOW_BREAKPOINT, DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { MultiSelect } from 'primereact/multiselect';
import Icon from '../../Common/Icon';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import BaselineFileDrawer from './BaselineFileDrawer';
import DropZone from 'react-dropzone';
import { Dropdown } from 'primereact/dropdown';
import './BaselineFilesPage.scss';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';

export class BaselineFilesPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        const defaultFile = {
            id: '0',
            name: '',
            description: '',
            departmentName: '',
            projectName: '',
            createdByDate: '',
        };

        this.state = {
            isLoading: false,
            isProjectEnabled: false,
            defaultFile: defaultFile,
            selectedFile: defaultFile,
            isEditDrawerOpen: false,
            departments: [],
            projects: [],
            createdDates: [],
            totalCount: 0,
            files: [],
            isDropZoneActive: false,
            droppedFile: null,
            searchParams: {
                subscriptionId: this.props.subscriptionId,
                name: '',
                description: '',
                departments: [],
                departmentIds: [],
                projects: [],
                projectIds: [],
                createdDates: [],
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: 'name',
                sortDir: 'asc',
            },
        };
    }

    componentDidMount = async () => {
        document.title = 'Admin';
        await this.loadFiltersAndSearch();
    };

    loadFiltersAndSearch = async () => {
        try {
            this.setState({ isLoading: true });
            await Promise.all([this.loadListFilters(), this.search()]);
        } catch (error) {
            Notification('error', 'Error', error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    loadListFilters = async () => {
        try {
            const response = await this.props.filesActions.loadListFilters(this.props.subscriptionId);
            if (response.type === types.LOAD_FILES_LIST_FILTERS_SUCCESS) {
                this.setState({
                    isProjectEnabled: response.payload.isProjectEnabled,
                    departments: response.payload.departments,
                    projects: response.payload.projects,
                    createdDates: response.payload.createdDates,
                });
            } else if (response.type === types.LOAD_FILES_LIST_FILTERS_FAILURE) {
                Notification('error', 'Error', response.payload.message);
            }
        } catch (error) {
            Notification('error', 'Error', error);
        }
    };

    search = async () => {
        try {
            const departmentIds = this.state.searchParams.departments.map((x) => x.id);
            const projectIds = this.state.searchParams.projects.map((x) => x.id);
            const createdDates = this.state.searchParams.createdDates.map((x) => x.id);

            const params = {
                ...this.state.searchParams,
                departmentIds: departmentIds,
                projectIds: projectIds,
                createdDates: createdDates,
            };
            const response = await this.props.filesActions.search(params);
            if (response.type === types.SEARCH_FILES_SUCCESS) {
                this.setState({
                    totalCount: response.payload.results.length,
                    files: response.payload.results,
                });
            } else if (response.type === types.SEARCH_FILES_FAILURE) {
                Notification('error', 'Error', response.payload.message);
            }
        } catch (error) {
            Notification('error', 'Error', error);
        }
    };

    filterChange = (e) => {
        let name = e.target.name;
        this.setState({ searchParams: { ...this.state.searchParams, [name]: e.target.value } });
    };

    onSearchBlur = () => {
        this.search();
    };

    keyUpFilter = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    };

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: e.page + 1 } }, () => {
            this.search();
        });
    };

    onDepartmentChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, departments: e.value } }, () => {
            this.search();
        });
    };

    onProjectChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, projects: e.value } }, () => {
            this.search();
        });
    };

    onCreatedDateChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, createdDates: e.value } }, () => {
            this.search();
        });
    };

    selectRow = (e) => {
        const file = e.value;
        const selectedFile = { ...this.state.defaultFile, ...file };
        this.setState({ selectedFile: selectedFile, isEditDrawerOpen: true });
    };

    onUpload = () => {
        this.setState({ selectedFile: this.state.defaultFile, isEditDrawerOpen: true });
    };

    onUploadComplete = () => {
        this.setState({ isEditDrawerOpen: false, selectedFile: this.state.defaultFile, droppedFile: null }, () => {
            this.loadFiltersAndSearch();
        });
    };

    onUploadCancel = () => {
        this.setState({ isEditDrawerOpen: false, selectedFile: this.state.defaultFile, droppedFile: null });
    };

    isMobile = () => {
        return this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT;
    };

    onDrop = (files) => {
        // Do not respond to file drag n drop when on mobile
        if (this.isMobile()) {
            return;
        }

        const droppedFile = files && files.length > 0 ? files[0] : null;
        this.setState({
            droppedFile: droppedFile,
            selectedFile: {
                ...this.state.defaultFile,
                file: droppedFile,
            },
            isDropZoneActive: false,
            isEditDrawerOpen: true,
        });
    };

    onDragEnter = () => {
        // Do not respond to file drag n drop when on mobile
        if (this.isMobile()) {
            return;
        }

        this.setState({ isDropZoneActive: true });
    };

    onDragLeave = () => {
        // Do not respond to file drag n drop when on mobile
        if (this.isMobile()) {
            return;
        }

        this.setState({ isDropZoneActive: false });
    };

    activeTemplate = (rowData) => {
        if (rowData.isActive) {
            return (
                <div className='text-success text-center'>
                    <Icon name='check-circle' />
                </div>
            );
        } else {
            return (
                <div className='text-danger text-center'>
                    <Icon name='times-circle' />
                </div>
            );
        }
    };

    onActiveChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, isActive: e.value } }, () => {
            this.search();
        });
    };

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState(
                {
                    searchParams: {
                        ...this.state.searchParams,
                        sortBy: sortBy,
                        sortDir: sortDir,
                    },
                },
                this.search
            );
        }
    };

    render() {
        const displayColumns = this.isMobile() ? 'none' : '';

        const nameFilterElement = (
            <input
                type='text'
                name='name'
                className='p-inputtext p-component p-column-filter'
                placeholder='Filter by Name'
                onBlur={this.onSearchBlur}
                onChange={this.filterChange}
                onKeyUp={this.keyUpFilter}
                value={this.state.searchParams.name}
            />
        );

        const descriptionFilterElement = (
            <input
                type='text'
                name='description'
                className='p-inputtext p-component p-column-filter'
                placeholder='Filter by Description'
                onBlur={this.onSearchBlur}
                onChange={this.filterChange}
                onKeyUp={this.keyUpFilter}
                value={this.state.searchParams.description}
            />
        );
        const departmentFilter = (
            <div>
                <MultiSelect
                    optionLabel='name'
                    appendTo='self'
                    value={this.state.searchParams.departments}
                    options={this.state.departments}
                    onChange={this.onDepartmentChange}
                />
            </div>
        );

        const projectFilter = (
            <div>
                <MultiSelect
                    optionLabel='name'
                    appendTo='self'
                    value={this.state.searchParams.projects}
                    options={this.state.projects}
                    onChange={this.onProjectChange}
                />
            </div>
        );

        const createdDateFilter = (
            <MultiSelect
                optionLabel='name'
                appendTo='self'
                value={this.state.searchParams.createdDates}
                options={this.state.createdDates}
                onChange={this.onCreatedDateChange}
            />
        );
        const activeOptions = [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
            { label: 'All', value: null },
        ];

        const activeFilter = (
            <Dropdown appendTo='self' value={this.state.searchParams.isActive} options={activeOptions} onChange={this.onActiveChange} />
        );

        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                {this.state.isEditDrawerOpen ? (
                    <BaselineFileDrawer
                        subscriptionId={this.props.subscriptionId}
                        fileId={this.state.selectedFile.id.toString()}
                        onComplete={this.onUploadComplete}
                        onCancel={this.onUploadCancel}
                        filesActions={this.props.filesActions}
                        isMobile={this.isMobile()}
                        droppedFile={this.state.droppedFile}
                    />
                ) : null}
                <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
                    <div>
                        <DropZone
                            multiple={false}
                            className='dropzone'
                            onDrop={this.onDrop}
                            onDragEnter={this.onDragEnter}
                            onDragLeave={this.onDragLeave}
                            disabled={this.state.isEditDrawerOpen}
                            noClick={true}>
                            {({ getRootProps, getInputProps, isDragActive }) => (
                                <div {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
                                    <input {...getInputProps()} tabIndex={-1} style={{ display: 'none' }} />{' '}
                                    {this.state.isDropZoneActive ? (
                                        <div className='dropzone-overlay'>
                                            <div className='overlay-content'>
                                                <Icon name='cloud-upload-alt' />
                                                <p>Drop file here to upload</p>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className='identifier-header'>
                                                <div className='title'>Baseline Files</div>
                                                <div className='close'>
                                                    <button type='button' onClick={this.props.onClose} alt='close popup'>
                                                        <Icon name='times' />
                                                    </button>
                                                </div>
                                            </div>

                                            {!this.isMobile() && (
                                                <div className='identifier-add-new'>
                                                    <div className='col-sm-12'>
                                                        <button
                                                            type='button'
                                                            className='btn btn-primary upload-button'
                                                            onClick={this.onUpload}
                                                            alt='upload'>
                                                            <span className='me-2'>Upload</span>
                                                            <Icon name='plus-circle' />
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            <div className='identifier-results-table'>
                                                <DataTable
                                                    filterDisplay='row'
                                                    className='p-datatable-sm p-datatable-striped'
                                                    resizableColumns={true}
                                                    columnResizeMode='expand'
                                                    scrollable={true}
                                                    scrollHeight='400px'
                                                    value={this.state.files}
                                                    selectionMode='single'
                                                    selection={this.state.selectedFile}
                                                    onSelectionChange={this.selectRow}
                                                    sortField={sortField}
                                                    sortOrder={sortOrder}
                                                    onSort={this.onSort}>
                                                    <Column
                                                        field='name'
                                                        header='Name'
                                                        filter={true}
                                                        filterElement={nameFilterElement}
                                                        sortable={true}
                                                        style={{ minWidth: '150px' }}
                                                    />
                                                    <Column
                                                        field='description'
                                                        header='Description'
                                                        filter={true}
                                                        filterElement={descriptionFilterElement}
                                                        style={{ display: displayColumns, minWidth: '200px' }}
                                                        sortable={true}
                                                    />
                                                    <Column
                                                        field='departmentName'
                                                        header='Department'
                                                        filter={true}
                                                        filterElement={departmentFilter}
                                                        sortable={true}
                                                        style={{ minWidth: '150px' }}
                                                    />
                                                    <Column
                                                        field='projectName'
                                                        header='Project'
                                                        filter={true}
                                                        filterElement={projectFilter}
                                                        style={{ display: this.state.isProjectEnabled ? '' : 'none', minWidth: '150px' }}
                                                        sortable={true}
                                                    />
                                                    <Column
                                                        field='createdByDateFormat'
                                                        header='Date Added'
                                                        filter={true}
                                                        filterElement={createdDateFilter}
                                                        style={{ display: displayColumns, minWidth: '120px' }}
                                                        sortable={true}
                                                    />
                                                    <Column
                                                        field='isActive'
                                                        header='Active'
                                                        body={this.activeTemplate}
                                                        style={{ width: '120px', minWidth: '120px' }}
                                                        filter={true}
                                                        filterElement={activeFilter}
                                                        sortable={true}
                                                    />
                                                </DataTable>
                                                {this.state.totalCount > this.state.searchParams.pageSize && (
                                                    <Paginator
                                                        rows={this.state.searchParams.pageSize}
                                                        totalRecords={this.state.totalCount}
                                                        first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                                        onPageChange={this.onPageChange}
                                                    />
                                                )}
                                                <div className='results-count'>Total records: {this.state.totalCount}</div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </DropZone>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }
}

BaselineFilesPage.propTypes = {
    windowWidth: PropTypes.number.isRequired,
    subscriptionId: PropTypes.string.isRequired,
    filesActions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        filesActions: bindActionCreators(filesActions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        windowWidth: state.window.width,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BaselineFilesPage);
